import PageHeaderLoginButton from "./PageHeaderLoginButton";
import PageHeaderRegisterButton from "./PageHeaderRegisterButton";

const PageHeaderAuth = () => {


  return (
    <>
      <nav className="page-header__nav">
        <PageHeaderLoginButton />
        {/* <PageHeaderRegisterButton /> */}
      </nav>
    </>
  )
}

export default PageHeaderAuth;







